// JS for the long form content style of template // Only load functions if necessary
if(document.getElementById("article-tags-heading")) {
  articleJumpLinks();
}
if(document.getElementById('medically-reviewed')) {
  medicalReviewToggle();
}


if(document.getElementById('mega-menu')) {
  const drugRehabLink = document.getElementById("drug-rehab-link");
  const alcoholRehabLink = document.getElementById("alcohol-rehab-link");
  const drugRehabPanel = document.getElementById("drug-rehab-panel");
  const drugRehabSubPanel = document.getElementById("drug-rehab-sub-panel");
  const alcoholRehabSubPanel = document.getElementById("alcohol-rehab-sub-panel");
  
  if (drugRehabLink && alcoholRehabLink) {
    drugRehabLink.addEventListener("click", (e) => {
      megaMenuToggle(drugRehabLink, alcoholRehabLink, drugRehabPanel, drugRehabSubPanel, alcoholRehabSubPanel, e)
    })
    alcoholRehabLink.addEventListener("click", (e) => {
      megaMenuToggle(alcoholRehabLink, drugRehabLink, drugRehabPanel, drugRehabSubPanel, alcoholRehabSubPanel, e)
    })
  }
}

const drugRehabPanel = document.getElementById("drug-rehab-sub-panel");
if (drugRehabPanel) {
  lastHovered = null;
  const link = drugRehabPanel.querySelector(".drug-panel-link");
  const title = drugRehabPanel.querySelector(".drug-panel-title");
  const desc = drugRehabPanel.querySelector(".drug-panel-description");
  const thumbnail = drugRehabPanel.querySelector(".drug-panel-thumbnail");
  drugRehabPanel.addEventListener("mouseover", (e) => {
    const menuItem = e.target.closest(".mega-menu-link")
    if (!menuItem || menuItem === lastHovered) return;

    lastHovered = menuItem;

    updatePaginationMenuFeatured({link, title, desc, thumbnail, e, menuItem});
  })

  drugRehabPanel.addEventListener("mouseout", (e) => {
    const item = e.target.closest(".mega-menu-link");
    if (item && item === lastHovered) lastHovered = null; // If Item is True (exists) AND equals last hovered assign it null
  })
}

const alcoholRehabPanel = document.getElementById("alcohol-rehab-sub-panel");
if (alcoholRehabPanel) {
  lastHovered = null;
  const link = alcoholRehabPanel.querySelector(".alcohol-panel-link");
  const title = alcoholRehabPanel.querySelector(".alcohol-panel-title");
  const desc = alcoholRehabPanel.querySelector(".alcohol-panel-description");
  const thumbnail = alcoholRehabPanel.querySelector(".alcohol-panel-thumbnail");
  alcoholRehabPanel.addEventListener("mouseover", (e) => {
    const menuItem = e.target.closest(".mega-menu-link")
    if (!menuItem || menuItem === lastHovered) return;

    lastHovered = menuItem;

    updatePaginationMenuFeatured({link, title, desc, thumbnail, e, menuItem});
  })

  alcoholRehabPanel.addEventListener("mouseout", (e) => {
    const item = e.target.closest(".mega-menu-link");
    if (item && item === lastHovered) lastHovered = null; // If Item is True (exists) AND equals last hovered assign it null
  })
}

const paginationContainer = document.getElementById("pagination-menu-silo");
if (paginationContainer) {
  lastHovered = null;
  const link = paginationContainer.querySelector("#pagination-menu-feature");
  const title = paginationContainer.querySelector("#pagination-menu-title");
  const desc = paginationContainer.querySelector("#pagination-menu-description");
  const thumbnail = paginationContainer.querySelector("#pagination-menu-thumbnail");
  
  paginationContainer.addEventListener("mouseover", (e) => { 
    const menuItem = e.target.closest(".pagination-menu-link")
    if (!menuItem || menuItem === lastHovered) return;

    lastHovered = menuItem;

    updatePaginationMenuFeatured({link, title, desc, thumbnail, e, menuItem});
  })
  
  paginationContainer.addEventListener("mouseout", (e) => {
    const item = e.target.closest(".pagination-menu-link");
    if (item && item === lastHovered) lastHovered = null; // If Item is True (exists) AND equals last hovered assign it null
  })

}
// This might move to a more general function...
if(document.getElementById('attention-banner')) {
  topBanner = document.getElementById("attention-banner");
  window.addEventListener('scroll', topBannerController);
}

function topBannerController() {
  if(window.innerWidth > 768) {
    return;  
  }
  if(window.scrollY > 180) {
    topBanner.classList.add("sticky-on")
  }
  if(window.scrollY < 180) {
    topBanner.classList.remove("sticky-on")
  }
}

function medicalReviewToggle() {
  // set-up and gatekeep
  const popUpWrapper = document.getElementById('medically-reviewed-popup-wrapper');
  const popUpToggle = document.getElementById('medically-reviewed');
  const popUpClose = document.getElementById('medically-reviewed-popup__close');
  if (!popUpWrapper || !popUpToggle || !popUpClose) {
    return;
  }
  popUpToggle.addEventListener('click', function(e) {
    e.preventDefault;
    popUpWrapper.classList.toggle('medically-reviewed-popup-wrapper__visible')
  })
  popUpClose.addEventListener('click', function(e) {
    e.preventDefault;
    popUpWrapper.classList.remove('medically-reviewed-popup-wrapper__visible')
  })
}
 
function articleJumpLinks() {
  // Set Up toggle function // Only necessary if three items exist: 
  const headers = document.querySelectorAll('article h2');
  const tagSystemHeading = document.getElementById('article-tags-heading');
  const tagContainer = document.getElementById('article-tags');
  const tagWrapper = document.getElementById('article-tags-wrapper');
  const tagToggle = document.getElementById('article-tags-toggle');
  
  // Gatekeeping
  if(!tagToggle || !tagContainer || !tagSystemHeading || !tagWrapper) {
    return;
  }

  // Gatekeeping
  if(headers.length == 0) {
    tagSystemHeading.style.display = "none";
    tagSystemHeading.style.padding = 0;
    tagContainer.style.display = "none";
    tagWrapper.style.display = "none";
    tagToggle.style.display = "none";
    return;
  }

  // Add Toggle for menu system
  tagToggle.addEventListener('click', function(e) {
    e.preventDefault();
    tagContainer.classList.toggle('article-tag__toggled');
    tagWrapper.classList.toggle('__toggled');
  })

  // Clean up h2 Id's and then add them to container
  for (let i = 0; i < headers.length; i++) {
    const header = headers[i];

    if (!header.id) {
        header.id = generateIdFromText(header.innerText || header.textContent);
    }

    // Create a new tag element
    let newTag = document.createElement('a');
    newTag.className = 'article-tag';
    newTag.href = '#' + header.id; // Link to the header ID
    newTag.textContent = header.textContent.trim(); // Use header text for the tag

    // Append the new tag to the container 
    tagContainer.appendChild(newTag);
    }
}

//Utility Function
function generateIdFromText(text) {
  // Helper function for IDs
  return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
      .replace(/^-+|-+$/g, '')     // Remove leading/trailing hyphens
      .substring(0, 50);           // Limit ID length to 50 characters
}


function updatePaginationMenuFeatured({link, title, desc, thumbnail, e, menuItem}) {
  link.style.opacity = 0;
  title.innerText = menuItem.dataset.title;
  desc.innerText = menuItem.dataset.description;
  thumbnail.src = menuItem.dataset.thumbnail;
  link.href = menuItem.dataset.path;
  setTimeout(() => {
    link.style.opacity = 1;
  }, "300");
}

/* State is always open so this is reverse to what is possible expected */
function megaMenuToggle(targetLink, otherLink, drugRehabPanel, drugRehabSubPanel, alcoholRehabSubPanel, e) {
  e.preventDefault();

  if(targetLink.classList.contains("closed")) { // if it's closed open it - but check if it's alcohol or drugs open the right one and closed the other
    targetLink.classList.remove("closed")
    otherLink.classList.add("closed")
    if (targetLink.id === "drug-rehab-link") { // it's opening drug rehab  
      drugRehabPanel.classList.remove("closed")
      drugRehabSubPanel.classList.remove("closed")
      alcoholRehabSubPanel.classList.add("closed")
      return
    } 
    if (targetLink.id === "alcohol-rehab-link") {
      drugRehabPanel.classList.add("closed")
      drugRehabSubPanel.classList.add("closed")
      alcoholRehabSubPanel.classList.remove("closed")
      return
    }
  } else { // meaning the target link is open so they are trying to close it
    targetLink.classList.add("closed")
    otherLink.classList.add("closed")
    drugRehabPanel.classList.add("closed")
    drugRehabSubPanel.classList.add("closed")
    alcoholRehabSubPanel.classList.add("closed")
  }
}
